// src/pages/Fab/BracketCreation/bracketTeamUtils.js
import api from "@api";

/**
 * Check if a team is already placed in the bracket.
 */
export function isTeamInBracket(teamId, bracketData) {
  if (!bracketData) return false;

  for (const round of bracketData.rounds) {
    for (const match of round) {
      if (!match) continue;

      if (match.teamA?.slt_id === teamId) return true;
      if (match.teamB?.slt_id === teamId) return true;
    }
  }

  return false;
}

/**
 * Check if a team has a score in any game.
 */
export function teamHasScore(teamId, games) {
  for (const g of games) {
    const home = g.score_home;
    const away = g.score_away;

    // ❗ If either is null or undefined → no score yet
    if (home == null || away == null) continue;

    // ❗ If both are 0 → no score yet
    if (home === 0 && away === 0) continue;

    // ❗ If we get here → real score was entered
    if (g.home_team_id === teamId || g.away_team_id === teamId) {
      return true;
    }
  }

  return false;
}



/**
 * Remove a team from the bracket and persist.
 */
export async function removeTeamFromBracket(teamId, bracketData, divisionId, games) {
  // 1) Deep clone bracket
  const updated = JSON.parse(JSON.stringify(bracketData));

  // 2) Remove team from bracket slots
  for (const round of updated.rounds) {
    for (const match of round) {
      if (!match) continue;


// TEAM A
if (match.teamA?.slt_id === teamId) {
  const originalSlot = match.teamA._originalSlot;   // ⭐ TRUE SLOT NUMBER
  const label = `Slot ${originalSlot + 1}`;         // ⭐ Restore label

  match.teamA = {
    name: label,
    slt_id: null,
    position: originalSlot,         // ⭐ restore original slot seed
    _originalSlot: originalSlot,    // ⭐ keep original slot stored
    _slotLabel: label               // ⭐ label for UI
  };
}


// TEAM B
if (match.teamB?.slt_id === teamId) {
  const originalSlot = match.teamB._originalSlot;   // ⭐ TRUE SLOT NUMBER
  const label = `Slot ${originalSlot + 1}`;         // ⭐ Restore label

  match.teamB = {
    name: label,
    slt_id: null,
    position: originalSlot,         // ⭐ restore original slot seed
    _originalSlot: originalSlot,    // ⭐ keep original slot stored
    _slotLabel: label               // ⭐ label for UI
  };
}


    }
  }

  // ---- IMPORTANT NEW PART ----
  // 3) Remove team from any existing game (no delete)
  const updatePromises = [];

  for (const g of games) {
    let changed = false;

    if (g.home_team_id === teamId) {
      g.home_team_id = null;
      changed = true;
    }

    if (g.away_team_id === teamId) {
      g.away_team_id = null;
      changed = true;
    }

    if (changed) {
      updatePromises.push(
        api.put(`/api/seasonsv2/${g.seasons_leagues_id}/leagues/${divisionId}/games/${g.id}`, {
          home_team_id: g.home_team_id,
          away_team_id: g.away_team_id,
          // leave scores alone
        })
      );
    }
  }

  // Run game updates in background
  Promise.all(updatePromises).catch(err =>
    console.error("Failed updating games after team removal:", err)
  );

  // 4) Save the updated bracket (also async, non-blocking)
  api
    .put(`/api/divisions/${divisionId}/bracket`, {
      bracket_json: updated,
    })
    .catch((err) => console.error("Save error:", err));

  // 5) RETURN updated bracket immediately for UI
  return updated;
}